import React, { useContext } from "react";
import { RiSearch2Line, RiCloseLine } from "react-icons/ri";

import { GlobalContext } from "../../globals/globalContext";
import "./styles.styl";
import { useIntl } from "react-intl";
import classNames from "classnames";

export default React.forwardRef(function Search(props, ref) {
  const { colorPrimary } = useContext(GlobalContext) || props;
  const intl = useIntl();
  const onClearSearch = () => {
    props.search("");
  };
  return (
    <div className={classNames("search", props.className)}>
      <div className="search-container">
        <div className="search__icon">
          <RiSearch2Line size={20} color={colorPrimary} />
        </div>
        <input
          className="search-box"
          type="text"
          placeholder={intl.formatMessage({ id: "searchPrompt" })}
          name="search"
          aria-autocomplete="none"
          ref={ref}
          value={props.searchText}
          autoComplete="off"
          // Safari does not always respect the no-autocomplete
          //    therefore Re-apply autocomplete off on focus
          onFocus={(e) => e.target.setAttribute("autocomplete", "off")}
          onChange={(e) =>
            props.search(e.target.value.toLowerCase())
          }
        />
        {props.searchText && (
          <div
            className="search__icon search__close-icon"
            onClick={onClearSearch}
          >
            <RiCloseLine size={20} />
          </div>
        )}
      </div>
    </div>
  );
});
